import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    fontSize: '24px',
    height: 'calc(100vh - 64px)',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    maxWidth: '500px',
  },
}));
